import type { FunctionComponent } from "react";

import type { ISegmentsData } from "app/services/conversion/ConversionSegmentsService";

import { StyledPageTitle } from "../../styled components/StyledPageTitle/src/StyledPageTitle";

import AllContexts from "./components/AllContexts";
import { SitesVsCategoryOvertime } from "./components/benchmarkOvertime/SitesVsCategoryOvertime";
import { ConversionCategoryScatter } from "./components/ConversionScatterChart/ConversionCategoryScatter";
import { ConversionScatterContainer } from "./components/ConversionScatterChart/ConversionScatterContainer";
import { conversionVerticals } from "./constants/conversionVerticals";
import { ConversionContainer } from "./StyledComponents";
import type { IScatterData } from "./types/conversionTypes";

export interface ICategoryOverviewProps {
    pageFilters?: any;
    loading: boolean;
    data?: any;
    translate: (key: string) => string;
    track: (a?: FixmeType, b?: FixmeType, c?: FixmeType, d?: FixmeType) => void;
    components: any;
    selectedRows: any;
    graphData: any;
    tableData: any;
    segmentsData: ISegmentsData;
    onGraphDDClick: (props: FixmeType) => void;
    onScatterDDClick: (props: FixmeType) => void;
    tableExcelLink: string;
    scatterData: IScatterData;
    getLink: (a: FixmeType, b?: FixmeType, c?: FixmeType) => string;
    getAssetsUrl: (a: FixmeType) => string;
}

export const CategoryOverview: FunctionComponent<ICategoryOverviewProps> = ({
    translate,
    track,
    components,
    loading,
    pageFilters,
    selectedRows,
    graphData,
    onGraphDDClick,
    onScatterDDClick,
    tableExcelLink,
    scatterData,
    getLink,
    tableData,
    getAssetsUrl,
    segmentsData,
}) => {
    const sitesVsCategoryProps = {
        title: "conversion.category.sites.vs.category.title",
        titleTooltip: "conversion.category.sites.vs.category.title.tooltip",
        filters: pageFilters,
        data: graphData,
        selectedRows,
        isLoading: loading,
        onGraphDDClick,
        onScatterDDClick,
        tableExcelLink,
        rowSelectionProp: "SegmentId",
        industryAverageAvailable: true,
        segmentsData,
    };

    const scatterCategoryProps = {
        title: "conversion.category.scatter.title",
        titleTooltip: "conversion.category.sactter.title.tooltip",
        filters: pageFilters,
        data: scatterData,
        segmentsData,
        isLoading: loading,
        ScatterComponent: ConversionCategoryScatter,
        excludeVertical: [conversionVerticals.Stickiness.name],
        benchmarkTitle: "conversion.category.benchmark.title",
        confidenceDisclaimer: "conversion.category.scatter.disclaimer.confidence",
        supportMultiChannel: true,
        getAssetsUrl,
    };

    const tableProps = {
        isLoading: loading,
        tableData,
        selectedRows,
        segmentsData,
        tableSelectionKey: "CategoryConversionTable",
        tableSelectionProperty: "SegmentId",
    };

    const { CategoryConversionTableContainer } = components;
    return (
        <AllContexts
            translate={translate}
            track={track}
            linkFn={getLink}
        >
            <ConversionContainer>
                <StyledPageTitle data-automation-page-title={true}>
                    {translate("conversion.category.overview.title")}
                </StyledPageTitle>
                <ConversionScatterContainer {...scatterCategoryProps} />
                <SitesVsCategoryOvertime {...sitesVsCategoryProps} />
                <CategoryConversionTableContainer {...tableProps} />
            </ConversionContainer>
        </AllContexts>
    );
};
